import { Injectable } from '@angular/core';

import { topicsList } from '@api/sdk.gen';
import type { Topic } from '@api';

import { mapTopicsFromApi, type TopicItem } from '../../models/nat-curriculum.model';

@Injectable({ providedIn: 'root' })
export class TopicsApiService {
	getTopics(): Promise<TopicItem[]> {
		return topicsList({
			throwOnError: true,
			responseStyle: 'data' as const,
		}).then((dtos) => mapTopicsFromApi(dtos as unknown as Topic[]));
	}

	getTopicsByTag(tagId: string): Promise<TopicItem[]> {
		return topicsList({
			query: { tagId },
			throwOnError: true,
			responseStyle: 'data' as const,
		}).then((dtos) => mapTopicsFromApi(dtos as unknown as Topic[]));
	}
}
